import Vue from "vue";

const actions = {
  checkUniqueness(_, data) {
    let params = {
      entity: data.entity,
      [data.entity]: data.query
    };
    if (data.entity === "challengeName" || data.entity === "teamName") {
      params["programId"] = data.programId
        ? data.programId
        : Vue.auth.user().programId;
    }

    return Vue.axios
      .get(`programs/unique-search`, { params })
      .then(response => response.data)
      .catch(error => {
        if (error.response) {
          return error.response.data;
        }
        return `${data.query} is not valid.`;
      });
  },

  /*
   * this is called on logout to ensure security of previously logged in user
   */
  resetState({ commit }) {
    commit("SET_EXPANDED", true, { root: true });
    // authMember store resets to clear sidebar admin links
    commit("authMember/SET_IS_NON_ADMIN", true, { root: true });
    commit("authMember/SET_IS_ADMIN", false, { root: true });
    commit("authMember/SET_IS_WT_ADMIN", false, { root: true });
    commit("authMember/SET_IS_WT_ADMIN_SUPER", false, { root: true });

    // members store resets to clear any member data
    commit("members/SET_MEMBER", {}, { root: true });
    commit(
      "members/SET_LOADED_STATUS",
      { key: "memberLoaded", value: false },
      { root: true }
    );
    commit("members/SET_CHALLENGES", [], { root: true });
    commit("members/SET_MAKE_AN_ENTRY_JOURNAL", {}, { root: true });
    commit("members/SET_STEP_DATA", [], { root: true });
    commit("members/SET_JOURNALS", [], { root: true });
    commit("members/SET_MEMBER_TEAMS", [], { root: true });
    commit(
      "members/SET_LOADED_STATUS",
      { key: "memberTeamsLoaded", value: false },
      { root: true }
    );
    commit("members/SET_MEMBER_TEAM_INVITES", {}, { root: true });
    commit(
      "members/SET_LOADED_STATUS",
      { key: "friendsLoaded", value: false },
      { root: true }
    );

    // program store resets
    commit("program/SET_PROGRAM_TEAMS", [], { root: true });
    commit(
      "members/SET_LOADED_STATUS",
      { key: "programTeamsLoaded", value: false },
      { root: true }
    );
    commit("program/SET_CHALLENGES", [], { root: true });
    commit("organizations/RESET_ORGANIZATIONS_STATE", null, { root: true });

    commit("challenges/CLEAR_ALL_LEADERBOARDS", null, { root: true });

    // reset page loading state
    const pages = ["MyDashboard", "Sitewide", "Challenges", "Teams"];

    pages.forEach(page => {
      commit(
        "pages/SET_PAGE_LOADED",
        { key: page, value: false },
        { root: true }
      );
      commit(
        "pages/SET_PAGE_LOADING",
        { key: page, value: false },
        { root: true }
      );
    });
  }
};

export default actions;
